module.exports = __webpack_public_path__ + "img/VirtualCapabilities_00313.90ca6218.jpg";